/**
 * SALES-FORECASTING MODULE
 * Self-contained. Import only from /shared or within this module.
 * Do not import from other modules directly.
 */

// MobileFilterDrawer.jsx — ported from the source app shared/ (verbatim layout)
//
// Wraps a module's filter strip so it (a) collapses to a single 44px-tall
// toggle row on mobile, (b) shows a chip count + plain-language summary of
// what's filtering the data, (c) renders inline as a flex row on desktop
// with zero wrapper chrome (pass-through above 768px).

import React, { useState } from "react";
import "./MobileFilterDrawer.css";

export default function MobileFilterDrawer({
  children,
  summary = "",
  activeCount = 0,
  onReset,
  defaultOpen = false,
}) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={`mfd-root${open ? " mfd-open" : ""}`}>
      {/* Mobile-only toggle row. CSS hides it >=769px. */}
      <button
        type="button"
        className="btn mfd-toggle"
        onClick={() => setOpen(o => !o)}
        aria-expanded={open}
        aria-controls="mfd-panel"
      >
        <span className="mfd-toggle-icon" aria-hidden>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="4" y1="6" x2="20" y2="6"/>
            <line x1="6" y1="12" x2="18" y2="12"/>
            <line x1="9" y1="18" x2="15" y2="18"/>
          </svg>
        </span>
        <span className="mfd-toggle-label">
          Filters
          {activeCount > 0 && <span className="mfd-toggle-count">· {activeCount} active</span>}
        </span>
        {!open && summary && (
          <span className="mfd-toggle-summary" title={summary}>{summary}</span>
        )}
        <span className={`mfd-toggle-chevron${open ? " mfd-toggle-chevron-open" : ""}`} aria-hidden>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="6 9 12 15 18 9"/>
          </svg>
        </span>
      </button>

      <div id="mfd-panel" className="mfd-panel" role="region" aria-label="Filters">
        {children}
        <div className="mfd-footer">
          {onReset && (
            <button type="button" className="mfd-footer-btn mfd-footer-reset" onClick={onReset}>
              Reset
            </button>
          )}
          <button type="button" className="mfd-footer-btn mfd-footer-done" onClick={() => setOpen(false)}>
            Done
          </button>
        </div>
      </div>
    </div>
  );
}
